import App from "./App.svelte";
import props from "./props/index.js";

let app;

let init = () => {
  /* ---------------------------- Svelte component ---------------------------- */
  app = new App({
    target: document.querySelector("#server-rendered-html"),
    hydrate: true,
    props: { ...props },
  });

  /*
  app.$on("update", () => {
    var documentHeight = document.querySelector("body").offsetHeight;
    window.parent.postMessage(
      { height: documentHeight, requestData: requestData },
      "*"
    );
    console.log("messageOnUpdate", {
      height: documentHeight,
      requestData: requestData,
    });
  });
  */
};

document.addEventListener("DOMContentLoaded", init);

export default app;
